<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.1989 1C15.0824 1 19.8519 5.75557 19.8519 11.8633C19.8519 13.3906 19.5537 14.8272 19.0144 16.123C22.3016 16.7301 24 18.0902 24 19.7906C24 22.1148 19.0828 23.9989 13.017 23.9989C10.237 23.9989 7.69823 23.6032 5.76352 22.9506C7.30674 23.2446 9.07011 23.4117 10.943 23.4117C17.0087 23.4117 21.926 21.659 21.926 19.497C21.926 18.4204 20.7066 17.4453 18.7334 16.7376C18.3897 17.4391 17.9715 18.0929 17.4904 18.691C17.8279 18.0287 18.1024 17.3266 18.3058 16.5933C17.1862 16.2315 15.8585 15.9521 14.3943 15.7795L14.4235 15.7798L14.7611 15.778C16.1406 15.778 17.3706 15.8654 18.4476 16.0276C18.6261 15.2241 18.7206 14.387 18.7206 13.5271C18.7206 7.41932 13.9511 2.46802 8.0676 2.46802C5.35574 2.46802 2.88055 3.51993 1 5.25216C2.67523 2.59264 5.56216 1 9.1989 1Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgSCRLAServSafe',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>